import React from "react";
import { Link } from "react-router-dom";

function AboutOne() {
  return (
    <section className="about-modern">
      <div className="container-box">
        {/* TEXT COLUMN */}
        <div className="text-column">
          <h5 className="about-sub">Why Choose Our Printing Solutions?</h5>

          <h2 className="about-title">
            Smarter technology, trusted brands, and a shopping experience built
            around your needs.
          </h2>

          <p className="about-desc">
            We believe choosing a printer should be simple. That’s why we
            hand-select every model based on performance, durability, and real
            customer satisfaction. Whether you print once a week or manage a
            busy office, our curated catalog helps you find the perfect match —
            backed by expert guidance and fast, reliable support.
          </p>

          <div className="feature-list">
            <div className="feature-item">
              <div className="feature-icon">
                <img src="/assets/img/icon/quality.svg" alt="" />
              </div>
              <div>
                <h4>Trusted & Verified Products</h4>
                <p>
                  Every printer is evaluated for speed, efficiency, and
                  reliability before we offer it to customers.
                </p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <img src="/assets/img/icon/support.svg" alt="" />
              </div>
              <div>
                <h4>Expert Guidance, Anytime</h4>
                <p>
                  Need help choosing? Our specialists provide honest
                  recommendations based on your printing needs.
                </p>
              </div>
            </div>
          </div>

          <Link to="/contact" className="about-btn">
            Contact Our Team →
          </Link>
        </div>

        {/* IMAGE COLUMN */}
        <div className="image-column">
          <div className="grid-img img-main">
            <img src="/assets/img/normal/about_1_1.jpg" alt="Printers" />
          </div>

          <div className="grid-img img-small">
            <img src="/assets/img/normal/about_1_2.jpg" alt="Home Printer" />
          </div>

          <div className="grid-img img-small">
            <img src="/assets/img/normal/about_1_3.jpg" alt="Office Printer" />
          </div>
        </div>
      </div>

      {/* === SCOPED CSS === */}
      <style>{`
        .about-modern {
          padding: 100px 0;
          background: #f9fafb;
        }

        .about-modern .container-box {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 50px;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
        }

        /* TEXT SIDE */
        .about-modern .about-sub {
          font-size: 16px;
          font-weight: 600;
          color: #4C8BF5;
          text-transform: uppercase;
          margin-bottom: 12px;
          letter-spacing: 1px;
        }

        .about-modern .about-title {
          font-size: 34px;
          font-weight: 800;
          line-height: 1.3;
          margin-bottom: 18px;
          color: #0f172a;
        }

        .about-modern .about-desc {
          font-size: 16px;
          color: #475569;
          line-height: 1.6;
          margin-bottom: 28px;
          max-width: 550px;
        }

        /* FEATURES */
        .about-modern .feature-list {
          display: flex;
          flex-direction: column;
          gap: 22px;
          margin-bottom: 25px;
        }

        .about-modern .feature-item {
          display: flex;
          align-items: flex-start;
          gap: 15px;
        }

        .about-modern .feature-icon img {
          width: 45px;
          height: 45px;
        }

        .about-modern .feature-item h4 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
          color: #0f172a;
        }

        .about-modern .feature-item p {
          font-size: 14px;
          color: #64748b;
        }

        /* BUTTON */
        .about-modern .about-btn {
          display: inline-block;
          padding: 12px 28px;
          background: #4C8BF5;
          color: #fff;
          border-radius: 6px;
          font-weight: 700;
          text-decoration: none;
          transition: .25s;
        }

        .about-modern .about-btn:hover {
          background: #2364d8;
        }

        /* IMAGE GRID */
        .about-modern .image-column {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .about-modern .grid-img {
          overflow: hidden;
          border-radius: 12px;
        }

        .about-modern .grid-img img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform .35s ease;
        }

        .about-modern .grid-img:hover img {
          transform: scale(1.05);
        }

        .about-modern .img-main {
          grid-column: span 2;
          height: 340px;
        }

        .about-modern .img-small {
          height: 180px;
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .about-modern .container-box {
            grid-template-columns: 1fr;
          }

          .about-modern .about-title {
            font-size: 28px;
          }
        }
      `}</style>
    </section>
  );
}

export default AboutOne;
